<section class="job-openning-detail-wrapper">
  <div class="list">
    <ng-container *ngFor="let item of jobsList">
      <div class="job">
        <div class="job__left">
          <h1 class="job__title">{{ item.data['jobName'].iv }}</h1>
          <div class="job__detail">
            <span class="span_highlight">{{ item.data.jobLocation ? item.data.jobLocation.iv : 'Bangkok' }}</span>
            <span class="span_highlight">{{ item.data.JobType.iv }}</span>
            <span class="span_highlight">{{ item.data.JobTeam.iv }}</span>
          </div>
        </div>
        <div class="job__right">
          <a
            class="box__link flowbtn apply-btn"
            href="{{ item.data.jobGoogleFormUrl.iv }}"
            target="_blank"
            rel="noopener noreferrer"
            >Apply</a
          >
          <a
            class="box__link flowbtn linked-in-btn"
            href="https://th.linkedin.com/company/flowaccount"
            target="_blank"
            rel="noopener noreferrer"
            >Apply with LinkedIn</a
          >
        </div>
      </div>
      <div
        class="job__request"
        [innerHtml]="
          translate.currentLang === 'th' ? item.data['jobDetailTranslate'].th : item.data['jobDetailTranslate'].en
        "
      ></div>
      <div class="company-image-wrapper">
        <div class="image-wrapper">
          <picture>
            <img class="company-image" src="https://breezy-gallery.imgix.net/d3575/DSC_1045.jpg" alt="Stripe banner" />
          </picture>

          <picture>
            <img class="company-image" src="https://breezy-gallery.imgix.net/289dc/DSC_1067.jpg" alt="Stripe banner" />
          </picture>

          <picture>
            <img class="company-image" src="https://breezy-gallery.imgix.net/4f1d9/DSC_1097.jpg" alt="Stripe banner" />
          </picture>

          <picture>
            <img class="company-image" src="https://breezy-gallery.imgix.net/20c67/DSC_1145.jpg" alt="Stripe banner" />
          </picture>

          <picture>
            <img class="company-image" src="https://breezy-gallery.imgix.net/5e817/P1080774.jpg" alt="Stripe banner" />
          </picture>

          <picture>
            <img
              class="company-image"
              src="https://breezy-gallery.imgix.net/035d2/DSC_1119.jpg"
              alt="Stripe banner"
            /> </picture
        ></div>
      </div>
    </ng-container>
  </div>
</section>
